import React, { Component } from 'react';
import SearchInput from './SearchInput';
import PropTypes from 'prop-types';

import PostPreview from './PostPreview';

import './styles/Search.scss';

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hits: null,
    };

    this.renderFilteredPosts = this.renderFilteredPosts.bind(this);
  }

  renderFilteredPosts() {
    const { hits } = this.state;
    const { edges } = this.props;

    const posts = edges.filter(
      ({ node }) =>
        !hits || hits.filter(hit => hit.id === node.id).length > 0,
      ).map(({ node }) => {
        const { banner } = node.frontmatter;
        const postPreviewImage = (banner)
        ? banner.childImageSharp.sizes
        : this.props.defaultPreview.sizes;

        return (
          <PostPreview
            key={node.id}
            data={node}
            image={postPreviewImage}
            className="postPreview--fullWidth"
          />
        );
      });

    return posts;
  }

  render() {
    return (
      <div className="searchComponent" >
        <SearchInput
          data={this.props.searchData}
          onSearch={(text, hits) => {
              this.setState({
                hits: text !== '' ? hits : null,
              })
            }
          }
        />

        <div>
          {
            this.renderFilteredPosts()
          }
        </div>
      </div>
    );
  }
}

Search.propTypes = {
  siteSearchIndex: PropTypes.object,
  edges: PropTypes.array,
}

export default Search;



// WEBPACK FOOTER //
// ./src/components/Search.jsx